import { render } from "./AmbulanceAdministrationModal.vue?vue&type=template&id=ac4deaf2&scoped=true"
import script from "./AmbulanceAdministrationModal.vue?vue&type=script&lang=js"
export * from "./AmbulanceAdministrationModal.vue?vue&type=script&lang=js"

import "./AmbulanceAdministrationModal.vue?vue&type=style&index=0&id=ac4deaf2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac4deaf2"]])

export default __exports__